import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
@Injectable()
export class IndusindBankService {
    api_url: string = environment.apiEndPoint;

    constructor(private http: HttpClient) { }
    getToken() {
        return localStorage.getItem(environment.TOKEN_SECRET);
    }
    getIndusindBankAudit(filter: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'get-indusind-bank-audit', filter, configs)
    }
    getIndusindBankTransactions(filter: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'indusind-bank-transactions', filter, configs)
    }
    // Unused endpoint - not called anywhere in the app
    // saveIndusindBankTransactions(updateData: any) {
    //     const configs = {
    //         withCredentials: true,
    //         headers: { Authorization: `Bearer ${this.getToken()}` },
    //     };
    //     return this.http.post<any>(this.api_url + 'save-indusind-bank-transactions', updateData, configs)
    // }
}


// WEBPACK FOOTER //
// ./src/app/services/indusindbank.service.ts